import React, { useState } from "react";
import { readUtmFromLocation } from "./utm";

const PHONE_RE = /^[6-9]\d{9}$/;

const PhoneCaptureForm = ({
  source = "pathyacharya_page",
  campaign = "hindi_landing",
  term,
  ctaLabel = "मुझे call back करें",
  successLabel = "हो गया! हमारी टीम आपको जल्द कॉल करेगी।",
  helperLabel = "10 digit Indian mobile — हम आपको कॉल करके मदद करेंगे, spam नहीं भेजेंगे।",
}) => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!PHONE_RE.test(phone)) {
      setError("कृपया सही 10-digit मोबाइल नंबर डालें (शुरुआत 6-9)");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch("/api/lead", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone,
          source,
          campaign,
          term,
          path: typeof window !== "undefined" ? window.location.pathname : "",
          utm: readUtmFromLocation(),
        }),
      });
      if (res.status === 429) {
        setError("बहुत अधिक प्रयास — कुछ मिनट बाद try करें।");
        return;
      }
      if (!res.ok) {
        setError("कुछ गड़बड़ हुई — कृपया दोबारा try करें।");
        return;
      }
      setSubmitted(true);
    } catch (_err) {
      setError("नेटवर्क समस्या — कृपया दोबारा try करें।");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="bg-green-50 border border-green-300 rounded-xl p-4 text-green-800 max-w-md">
        <p className="font-semibold">{successLabel}</p>
        <p className="text-sm mt-1">तब तक Google Play से app install कर सकते हैं।</p>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-md"
      data-testid="phone-capture-form"
    >
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 select-none">
            +91
          </span>
          <input
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
            placeholder="98765 43210"
            className="w-full pl-12 pr-3 py-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-base"
            aria-label="Mobile number"
          />
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="bg-blue-600 hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold px-5 py-3 rounded-lg transition-colors whitespace-nowrap"
        >
          {submitting ? "भेज रहे हैं..." : ctaLabel}
        </button>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
      {!error && (
        <p className="mt-2 text-xs text-gray-500">{helperLabel}</p>
      )}
    </form>
  );
};

export default PhoneCaptureForm;
